import React from 'react'
import { injectIntl } from 'react-intl'
import MUIButton from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/core/styles'
import { compose } from 'recompose'
import history from '../utilties/history'

const useStyles = makeStyles((theme) => ({
	button: {
		margin: 0,
		padding: '0',
		minWidth: 0,
	},
	text: {
		margin: 0,
		padding: '0',
		minWidth: 0,
	},
	input: {
		display: 'none',
	},
}))

const LinkDarkButton = ({
	intl,
	textId,
	type,
	size = 'large',
	width = '100px',
	path = '',
	backgroundColor = '',
	color = 'white',
	onClick = null,
	...other
}) => {
	const classes = useStyles()

	return (
		<MUIButton
			data-testid="link-dark-button"
			variant='text'
			size={size}
			classes={{
				root: classes.root,
				text: classes.text,
			}}
			onClick={() => path && history.push(path)}
			style={{
				fontSize: '16px',
				textAlign: 'center',
				padding: '5px 15px',
				margin: '5px',
				color,
				backgroundColor,
			}}>
			{intl.formatMessage({ id: textId })}
		</MUIButton>
	)
}

const enhance = compose(injectIntl)

export default enhance(LinkDarkButton)
